import { convertUnitComp } from './convertUnitComp'
import { convertUnitTimeline } from './convertUnitTimeline'

/** The starting town center uses "towncentre", every built one uses "town_center" */
function isTownCenter(item) {
	return String(item?.icon ?? '').includes('town_center')
}

function isKeep(item) {
	const last = String(item?.icon ?? '')
		.toLowerCase()
		.split('/')
		.pop()

	return /^keep([-_]|$)/.test(last ?? '')
}

function convertTownCenters(player) {
	const times = new Set()

	for (const item of player?.buildOrder ?? []) {
		if (!isTownCenter(item)) continue

		for (const time of item.constructed ?? []) {
			if (typeof time === 'number') times.add(time)
		}
	}

	return [...times].sort((a, b) => a - b)
}

function convertKeeps(player) {
	const times = new Set()

	for (const item of player?.buildOrder ?? []) {
		if (!isKeep(item)) continue

		for (const time of item.constructed ?? []) {
			if (typeof time === 'number') times.add(time)
		}
	}

	return [...times].sort((a, b) => a - b)
}

export function convertSummary(data) {
	let players = data.players.map((player) => {
		let unitData = convertUnitTimeline(player)

		let timeline = player.resources.timestamps.map((time, index) => {
			return {
				time: time,
				resources_total: player.resources.food[index],
				resources_food: player.resources.food[index],
				resources_gold: player.resources.gold[index],
				resources_wood: player.resources.wood[index],
				resources_stone: player.resources.stone[index],
				resources_oliveoil: player.resources.oliveoil ? player.resources.oliveoil[index] : null,
				score_total: player.resources.total[index],
				score_military: player.resources.military[index],
				score_economy: player.resources.economy[index],
				score_technology: player.resources.technology[index],
				score_society: player.resources.society[index],
				population_worker: unitData.timelineVillagers[index],
				//Fish + traders + vills
				population_economy: unitData.timelineEconomyUnits[index],
				//Cattle only
				population_cattle: unitData.timelineCattle[index],
				//Fish + traders + vills + cattle
				population_economy_total: unitData.timelineTotalEconomyUnits[index],
			}
		})

		return {
			name: player.name,
			civilization: player.civilization,
			apm: player.apm,
			result: player.result,
			scores: { ...player.score },
			timeline: timeline,
			totalResourcesGathered: player.totalResourcesGathered,
			maxVillagers: unitData.maxVillagers,
			maxTraders: unitData.maxTraders,
			maxFishingShips: unitData.maxFishingShips,
			maxEconomyUnits: unitData.maxEconomyUnits,
			feudalAge: player.actions.feudalAge?.[0],
			castleAge: player.actions.castleAge?.[0],
			imperialAge: player.actions.imperialAge?.[0],
			economyLost: unitData.economyLost,
			// Analyzed server side from the build order, see server/helpers/strategy
			strategy: player.strategy ?? null,
			// Age up choices: [{ pbgid, gameTime, name, icon }], oldest first
			ageUps: player.ageUps ?? [],
			// Landmarks/wings built: [{ pbgid, gameTime, name, icon, newAge }]
			analysis: { landmarks: player.analysis?.landmarks ?? [] },
			// Military units produced, most produced first: [{ key, name, count, icon }]
			unitComp: convertUnitComp(player),
			// Game times extra town centers were constructed, oldest first: [387, 640]
			townCenters: convertTownCenters(player),
			// Game times keeps were constructed, oldest first: [512, 903]
			keeps: convertKeeps(player),
		}
	})

	return {
		mapName: data.mapName,
		duration: data.duration,
		mapSizeMaxPlayers: data.mapSizeMaxPlayers,
		players,
	}
}
